import { Injectable } from '@angular/core';
import {Router} from '@angular/router';
import {Headers, Http, RequestOptions, Response} from '@angular/http';
import {ServiceConfig} from './service-config';
import {HttpClient} from '@angular/common/http';
@Injectable()
export class PermissionService {

  private host = ServiceConfig.host;
  private baseUrl = this.host + '/api/permission/';
  private data: any;
  private headers: Headers;
  private options: {};

  constructor(private http: HttpClient,
              private router: Router) {
    this.data = JSON.parse(localStorage.getItem('currentSmmData'));
    // console.log(this.data.token);
    this.headers = new Headers({
      'Content-Type': 'application/json'
    });
    this.options = {headers: this.headers};
  }

  public index() {
    let url = this.baseUrl + '?token=' + this.data.token;
    return this.http.get<any>(url);
  }

  public create(body) {
    let url = this.baseUrl + 'create?token=' + this.data.token;
    return this.http.post<any>(url, body);
  }

  public get(username: String) {
    let url = this.baseUrl + username + '?token=' + this.data.token;
    //console.log(url);
    return this.http.get<any>(url);
  }

  public update(alias: String, body) {
    //this.data = JSON.parse(localStorage.getItem('currentSmmData'));
    let url = this.baseUrl + alias + '/update?token=' + this.data.token;
    //console.log('url:'+ url);
    return this.http.post<any>(url, body);
  }

  public delete(alias: String, body) {
    let url = this.baseUrl + alias + '/delete?token=' + this.data.token;
    //console.log(url);
    return this.http.post<any>(url, body);
  }

  public getAllPermission() {
    let url = this.baseUrl + 'listPermission?token=' + this.data.token;
    //console.log(url);
    return this.http.get<any>(url);
  }

  // Tìm các role đang gán permission theo id
  public findRoleAssignedPermission(id: String, body) {
    let url = this.baseUrl + id + '/findRoleAssignedPermission?token=' + this.data.token;
     //console.log("tìm các role đang gán permission theo id");
     //console.log(url);
    return this.http.post<any>(url, body);
  }
}



// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/_services/permission.service.ts